import {
  CheckCriticalActionQuery,
  CheckCriticalActionQueryVariables,
} from '@generated/CheckCriticalActionQuery';
import { CHECK_CRITICAL_ACTION_QUERY } from '@graphql/queries/CheckCriticalActionQuery';
import { QueryReturnType, useGraphQuery } from '@hooks/useQuery';

/**
 * Hook to check if a user has a ongoing critical action
 * @param action - the critical action
 * @param agentID - the user's id
 * @param email - the user's email
 * @param skip - if the query has to be avoided
 * @returns boolean
 */
export function useCheckCriticalAction(
  action: string,
  agentID: string,
  email: string,
  skip?: boolean
): QueryReturnType<CheckCriticalActionQuery, CheckCriticalActionQueryVariables> {
  return useGraphQuery<CheckCriticalActionQuery, CheckCriticalActionQueryVariables>(
    CHECK_CRITICAL_ACTION_QUERY,
    {
      variables: {
        action,
        agentID,
        email,
      },
      skip,
    }
  );
}
